module.exports = __webpack_public_path__ + "static/golden-wolf-b61bdc48ab840571b5efc25a57c84467.png";